module.exports = __webpack_public_path__ + "static/media/img11.185cc458.png";